import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-3ce21372")
const _hoisted_1 = { style: {fontWeight: 'bolder', fontSize: '23px'} }
const _hoisted_2 = { style: {fontWeight: 'bolder', fontSize: '23px'} }
_popScopeId()

import { computed, ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  color: {
    type: String,
    default: '#796dd1'
  },
  title: {
    type: String,
    default: ''
  },
  datasource: {
    type: Array,
    default: () => []
  },
  large: {
    type: Boolean,
    default: () => false
  }
},
  setup(__props) {

const props = __props


const borderColor = computed(() => props.color)

const isLarge = computed(() => props.large)

const list = computed<{ label: string, value: number }[]>(() => props.datasource as any)

const bodyStyle = ref<any>({
  borderLeft: `5px solid ${borderColor.value} `
})


return (_ctx: any,_cache: any) => {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, {
    bodyStyle: bodyStyle.value,
    class: "count_card_body"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_row, { gutter: [0, 0] }, {
        default: _withCtx(() => [
          _createVNode(_component_a_col, { span: "6" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, _toDisplayString(__props.title.substring(0, _unref(isLarge)? 3: 2)), 1),
              _createElementVNode("div", _hoisted_2, _toDisplayString(__props.title.substring( _unref(isLarge)? 3: 2)), 1)
            ]),
            _: 1
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(list), (item) => {
            return (_openBlock(), _createBlock(_component_a_col, {
              key: item,
              span: 18 / _unref(list).length
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  style: _normalizeStyle({ color: _unref(borderColor), fontSize: '18px' })
                }, _toDisplayString(item.label), 5),
                _createElementVNode("div", {
                  style: _normalizeStyle({ color: _unref(borderColor), fontSize: '25px', fontWeight: 'bolder' })
                }, _toDisplayString(item.value.toLocaleString()), 5)
              ]),
              _: 2
            }, 1032, ["span"]))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["bodyStyle"]))
}
}

})